export const SELECTED_OPTIONS = "SELECTED_OPTIONS";
export const setSelectedOptions = selection => {
  return {
    type: SELECTED_OPTIONS,
    value: selection
  };
};
export const POPUP_LOC = "POPUP_LOC";

export const popupLoc = loc => {
  return {
    type: POPUP_LOC,
    value: loc
  };
};
